import React from 'react';

export interface UserName {

}

export const UserName = (props: { name: React.ReactNode; }) => {
    return (
        <a className={'user-item__name'}>{props.name}</a>
    )
}
